"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var baseComponent_1 = require("./base/baseComponent");
var ko = require("knockout");
var ajaxUtils_1 = require("../../app/utils/ajaxUtils");
var LitmobFavoriteButtonComponent = (function (_super) {
    __extends(LitmobFavoriteButtonComponent, _super);
    function LitmobFavoriteButtonComponent(params, element, templateNodes) {
        _super.call(this, params, element, templateNodes);
        this.isActive = ko.observable();
        this.id = params.id;
        this.isActive(params.active);
    }
    LitmobFavoriteButtonComponent.prototype.toggle = function () {
        var _this = this;
        if (!app.ensureAuth("Чтобы подписаться на литмоб, необходимо авторизоваться")) {
            return;
        }
        if (this.processing())
            return;
        this.processing(true);
        if (this.isActive()) {
            ajaxUtils_1.AjaxUtils.post("litmob/favorite", { id: this.id, deleted: true })
                .done(function (result) {
                if (!result.isSuccessful) {
                    alert(result.messages[0]);
                    return;
                }
                _this.isActive(false);
            })
                .always(function () {
                _this.processing(false);
            });
        }
        else {
            ajaxUtils_1.AjaxUtils.post("litmob/favorite", { id: this.id })
                .done(function (result) {
                if (!result.isSuccessful) {
                    alert(result.messages[0]);
                    return;
                }
                _this.isActive(true);
            })
                .always(function () {
                _this.processing(false);
            });
        }
    };
    return LitmobFavoriteButtonComponent;
}(baseComponent_1.default));
ko.components.register("litmob-favorite-button", {});
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = LitmobFavoriteButtonComponent;
//# sourceMappingURL=litmobFavoriteButton.js.map